import { Grid, Paper, useMediaQuery, useTheme } from '@mui/material';

import React from 'react';

import { AuthPageStyles } from '../../styles';
import { ForgotPasswordFormProps } from '../ForgotPasswordForm';

import CommonForgotPasswordLayout from '../genericComponents/CommonForgotPasswodLayout';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../store/hook';

const ForgotPasswordFormLayout01 = ({
  value,
  placeholderKey,
  helperText,
  labelKey,
  cancelRoutePath,
  locked,
  inputChangeHandler,
  onResetPasswordClick,
  alert,
  loading,
  alertRef,
}: ForgotPasswordFormProps): React.JSX.Element => {
  const { isICPEnabled } = useAppSelector((state) => state.headerDetails);
  // const classes = AuthPageStyles();
  // const theme = useTheme();
  const { classes } = AuthPageStyles({ isICPEnabled: isICPEnabled });
  const theme = useTheme();
  const lgUp = useMediaQuery(theme.breakpoints.up('lg'));
  const { t } = useTranslation();
  const documentTitle = document.title?.split('|')[0];

  return (
    <>
      <Grid container justifyContent="center" className={classes.forgotPasswordPaper}>
        <Grid item xl={6} lg={8} className={classes.grid}>
          <Paper
            elevation={lgUp ? 1 : 0}
            className={classes.forgotPasswordPaper}
            role="region"
            aria-label={documentTitle}>
            <form aria-label={t(locked ? 'accountLocked' : 'resetPassword')} onSubmit={onResetPasswordClick}>
              <Grid container justifyContent="center">
                <Grid item lg={12} sm={12}>
                  <CommonForgotPasswordLayout
                    value={value}
                    placeholderKey={placeholderKey}
                    helperText={helperText}
                    labelKey={labelKey}
                    alert={alert}
                    locked={locked}
                    loading={loading}
                    cancelRoutePath={cancelRoutePath}
                    inputChangeHandler={inputChangeHandler}
                    onResetPasswordClick={onResetPasswordClick}
                    alertRef={alertRef}
                  />
                </Grid>
              </Grid>
            </form>
          </Paper>
        </Grid>
      </Grid>
    </>
  );
};

export default ForgotPasswordFormLayout01;
